module.exports = __webpack_public_path__ + "img/lock.53a7400c.svg";